//codex-- Dedicated mobile-wall API contract; office requests never receive the wall=tech selector.
import axios from 'axios';

//codex-- Reuse the office attachment policy while keeping technician uploads in their own storage.
export const TECH_WALL_TYPES = { jpeg: 'image/jpeg', jpg: 'image/jpeg', png: 'image/png', gif: 'image/gif', pdf: 'application/pdf' };
export const TECH_WALL_ACCEPT = '.jpeg,.jpg,.png,.gif,.pdf,image/jpeg,image/png,image/gif,application/pdf';
export function attachmentError(file) {
  const extension = file.name.split('.').pop().toLowerCase();
  const mime = TECH_WALL_TYPES[extension];
  if (typeof mime !== 'string' || (file.type && file.type !== mime)) return 'Only JPEG, JPG, PNG, GIF, and PDF files are accepted.';
  if (!file.size || file.size > 10 * 1024 * 1024) return 'Choose a non-empty file up to 10 MB.';
  return '';
}

//codex-- Keep all post/reply/reaction traffic on the existing endpoint's technician-only dispatch branch.
export function createTechWallApi(apiUrl) {
  const endpoint = `${(apiUrl || '').replace(/\/$/, '')}/post_crud.php?wall=tech`;
  const result = (response) => {
    if (response.data?.success !== true) throw new Error(response.data?.error || response.data?.message || 'Unable to update Tech Wall.');
    return response.data;
  };
  const post = async (body) => result(await axios.post(endpoint, body, { withCredentials: true, headers: { 'Content-Type': 'application/json' } }));
  return {
    async list(before = null, signal) {
      const data = result(await axios.get(endpoint, { withCredentials: true, signal, params: { getList: 1, ...(before ? { before } : {}) } }));
      if (!Array.isArray(data.posts)) throw new Error('Unable to read Tech Wall posts.');
      return data;
    },
    async add(content, file) {
      if (!file) return post({ status: 'addComment', data: { comment: content } });
      const body = new FormData();
      body.append('status', 'addComment');
      body.append('data', JSON.stringify({ comment: content }));
      body.append('file', file);
      return result(await axios.post(endpoint, body, { withCredentials: true }));
    },
    reply: (postId, content) => post({ status: 'addReply', post_id: postId, data: { reply: content } }),
    react: (postId, type) => post({ status: 'reaction', data: { post_id: postId, reaction_type: type } }),
    remove: (postId) => post({ status: 'delete_comment', data: { post_id: postId } }),
  };
}
